export default "__VITE_ASSET__Bgocbr1f__"